import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Footer.css';
import ContactModal from './ContactModal';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost/ehaazri/api';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [copyrightText, setCopyrightText] = useState(`© ${currentYear} eHaazri. All rights reserved.`);
  const [footerDescription, setFooterDescription] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    fetchFooterConfig();
  }, []);

  const fetchFooterConfig = async () => {
    try {
      const response = await axios.get(`${API_URL}/landing_page_api.php`);
      if (response.data.status === 'success') {
        const config = response.data.data.config || {};

        // Set copyright text with current year replacement
        if (config.copyright_text) {
          const copyrightWithYear = config.copyright_text.replace(/©\s*\d{4}/, `© ${currentYear}`);
          setCopyrightText(copyrightWithYear);
        }

        // Set footer description
        if (config.footer_description) {
          setFooterDescription(config.footer_description);
        }
      }
    } catch (error) {
      console.error('Failed to fetch footer config:', error);
    }
  };

  const openContactModal = () => {
    setIsContactModalOpen(true);
  };

  const closeContactModal = () => {
    setIsContactModalOpen(false);
  };

  const handleHashNavigation = (e, targetId) => {
    e.preventDefault();

    // If we're not on the homepage, navigate there first
    if (location.pathname !== '/') {
      navigate('/');
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        const element = document.getElementById(targetId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      // If we're already on the homepage, just scroll
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <>
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>Product</h3>
              <ul>
                <li><a href="#features" onClick={(e) => handleHashNavigation(e, 'features')}>Features</a></li>
                <li><a href="#how-it-works" onClick={(e) => handleHashNavigation(e, 'how-it-works')}>How It Works</a></li>
                <li><a href="/haazri-frontend/#/register">Get Started</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h3>Support</h3>
              <ul>
                <li><a href="#faq" onClick={(e) => handleHashNavigation(e, 'faq')}>FAQ</a></li>
                <li><button onClick={openContactModal} className="footer-link-button">Contact Support</button></li>
              </ul>
            </div>
            <div className="footer-section">
              <h3>Company</h3>
              <ul>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/privacy">Privacy Policy</Link></li>
                <li><Link to="/terms">Terms of Service</Link></li>
              </ul>
            </div>
          </div>
          {footerDescription && (
            <div className="footer-description">
              <p>{footerDescription}</p>
            </div>
          )}
          <div className="footer-bottom">
            <p>{copyrightText}</p>
          </div>
        </div>
      </footer>

      {isContactModalOpen && <ContactModal onClose={closeContactModal} />}
    </>
  );
};

export default Footer;
